import { render, staticRenderFns } from "./VSetPassword.vue?vue&type=template&id=c3151bda&"
import script from "./VSetPassword.vue?vue&type=script&lang=js&"
export * from "./VSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports